import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../reducers';
import { addWebhookUrlThunk, removeWebhookUrlThunk } from '../../settingsSlice';
import Webhooks from './webhookComponents/Webhooks';

const UserWebhooks = () => {
  const dispatch = useDispatch();
  const userWebhooks = useSelector(
    (state: RootState) => state.settings.user.integrations.webhooks
  );

  const handleAddWebhook = async (name: string, url: string) => {
    await dispatch(addWebhookUrlThunk({ name, url }));
  };

  const handleRemoveWebhook = async (url: string) => {
    await dispatch(removeWebhookUrlThunk({ url }));
  };

  return (
    <Webhooks
      webhooks={userWebhooks}
      onAddWebhook={handleAddWebhook}
      onRemoveWebhook={handleRemoveWebhook}
    />
  );
};

export default UserWebhooks;
